<template>
  <div class="zoom">
    <el-tooltip class="item" effect="dark" content="Przybliż" placement="top">
      <button @click="zoom('in')">
        <span class="fas fa-search-plus"></span>
      </button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="Resetuj" placement="top">
      <button @click="reset">
        <span class="fas fa-expand-arrows-alt"></span>
      </button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="Oddal" placement="top">
      <button @click="zoom('out')">
        <span class="fas fa-search-minus"></span>
      </button>
    </el-tooltip>
  </div>
</template>

<script>
import Editor from '../../classes/Editor'

export default {
  methods: {
    zoom(direction) {
      direction == 'in' ? Editor.zoom.zoomIn() : Editor.zoom.zoomOut();
    },
    reset() {
      Editor.zoom.resetZoom(true);
    },
  },
};
</script>

<style lang="less">
.zoom {
  display: flex;
  justify-content: center;
  button {
    cursor: pointer;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0;
    transition: 0.3s;
    background: #fff;
    color: rgb(131, 131, 131);
    @media (min-width: 768px) {
      width: 45px;
      height: 45px;
    }
    + button {
      margin-left: 5px;
    }
  }
}
</style>
